<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:05:09
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">人员列表</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input type="text" @keyup.enter="getList" v-model="getListData.UserKey" placeholder="搜索姓名/手机号/身份证号" />
        </div>
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input type="text" @keyup.enter="getList" v-model="getListData.CertName" placeholder="搜索证书分类名称" />
        </div>
        <el-select v-model="getListData.CertStatusID" placeholder="证书状态" clearable @change="getList">
          <el-option v-for="(it, i) in statusOptions" :key="i" :label="it.label" :value="it.value" />
        </el-select>
        <div class="my-dateRange">
          <el-date-picker v-model="getListData.CertStartDate" type="date" value-format="yyyy-MM-dd"
            placeholder="证书开始时间">
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker v-model="getListData.CertEndDate" type="date" value-format="yyyy-MM-dd" placeholder="证书结束时间">
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
        <div class="right">
          <el-button @click="hanldExport" class="search-btn">导出</el-button>
        </div>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="RealName" label="姓名"> </el-table-column>
        <el-table-column prop="SexTxt" label="性别" align="center" width="80">
        </el-table-column>
        <el-table-column prop="Phone" label="手机号码" align="center" width="140">
        </el-table-column>
        <el-table-column prop="IDCard" label="身份证号" width="200" align="center">
        </el-table-column>
        <el-table-column prop="StudyDurationTxt" label="学习时长" width="160" align="center">
        </el-table-column>
        <el-table-column prop="StartStudyTime" label="首次学习时间" width="190" align="center">
        </el-table-column>
        <el-table-column prop="EndStudyTime" label="最后学习时间" width="190" align="center">
        </el-table-column>
        <el-table-column prop="address" label="学习记录" width="130" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row, '/member/studyRecord')">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="证书" width="130" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row, '/member/certificate')">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination :total="total" :pageSize="getListData.PageSize" v-model="getListData.PageIndex"></my-pagination>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/util/auth";
import { OrgnManage_UserExport, OrgnManage_GetUserList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "cert",
  data() {
    return {
      statusOptions: [
        { label: "已失效", value: 0 },
        { label: "生效中", value: 1 },
      ],
      isLoading: false,
      total: 0,
      tableData: [],
      getListData: {
        CertName: "",
        CertStartDate: "",
        CertEndDate: "",
        CertStatusID: "",
        UserKey: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    hanldExport() {
      const Token = getToken();
      const data = {
        ...this.getListData,
      };
      window.open(
        `${this.baseUrl}/pc/Member/OrgnManage_UserExport?Token=${Token}&CertName=${data.CertName}&CertStartDate=${data.CertStartDate}&CertEndDate=${data.CertEndDate}&CertStatusID=${data.CertStatusID}&UserKey=${data.UserKey}`,
        "_blank"
      );

      // OrgnManage_UserExport(data).then((res) => {
      //   console.log(res);
      //   const blob = new Blob([res], {
      //     type: "application/vnd.ms-excel;charset=utf-8",
      //   });
      //   const objectUrl = URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.style.display = "none";
      //   link.href = objectUrl;
      //   link.setAttribute("download", decodeURIComponent("人员列表"));
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // });
    },
    hanldDetail(data, path) {
      this.$router.push({
        path: path,
        query: {
          UserID: data.UserID,
        },
      });
    },
    getList() {
      this.isLoading = true;
      const data = {
        ...this.getListData,
      };
      OrgnManage_GetUserList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-search-box {
  position: relative;

  .my-search {
    width: 240px;
  }

  .el-select {
    ::v-deep .el-input__inner {
      width: 201px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }

  .el-date-editor {
    width: 180px;
    height: 47px;

    ::v-deep .el-input__inner {
      width: 180px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }

  .right {
    position: absolute;
    right: 0;

    .search-btn {
      width: 141px;
    }
  }
}

.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}

.bmName {
  font-size: 20px;
  color: #333333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.time {
  margin-top: 5px;
  font-size: 16px;
  color: #666666;
}

.StatusID {
  font-size: 16px;
  color: #1d79ff;
}

.my-form {
  .mt-form-item {
    margin-bottom: 20px;

    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }

    .must {
      color: #ef3d3d;
    }
  }

  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}

.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
